import { get, httpDelete, post, put } from "../../services/HttpService";

export class TdsChallan {
  constructor(tdsChallan = {}) {
    this.set(tdsChallan);
  }

  static validations = {
    challan_number: [
      { required: true, message: "Challan Type is required." }
    ],
    major_head: [
      { required: true, message: "Tax Applicable is required." }
    ],
    minor_head: [
      { required: true, message: "Tax Type is required." }
    ],
    assessment_year: [
      { required: true, message: "Assessment year is required." }
    ],
    nature_of_payment: [
      { required: true, message: "Tax Category is required." }
    ],
    income_tax: [
      { required: true, message: "Tax amount is required." },
      { pattern: new RegExp(/^([1-9][0-9]*)$/), message: "Please enter valid amount." }
    ],
    surcharge: [
      { required: true, message: "Provide valid amount. Enter 0 if not applicable." },
      { pattern: new RegExp(/^[0-9]+$/), message: "Please enter valid amount." }
    ],
    education_cess: [
      { required: true, message: "Provide a valid amount. Enter 0 if not applicable." },
      { pattern: new RegExp(/^[0-9]+$/), message: "Please enter valid amount." }
    ],
    equilization_levy: [
      { required: true, message: "Provide a valid amount. Enter 0 if not applicable." },
      { pattern: new RegExp(/^[0-9]+$/), message: "Please enter valid amount." }
    ],
    interest: [
      { required: true, message: "Provide a valid amount. Enter 0 if not applicable." },
      { pattern: new RegExp(/^[0-9]+$/), message: "Please enter valid amount." }
    ],
    other_fee: [
      { required: true, message: "Provide a valid amount. Enter 0 if not applicable." },
      { pattern: new RegExp(/^[0-9]+$/), message: "Please enter valid amount." }
    ],
    penalty: [
      { required: true, message: "Provide a valid amount. Enter 0 if not applicable." },
      { pattern: new RegExp(/^[0-9]+$/), message: "Please enter valid amount." }
    ],
    penalty_code: [],
    other_amount: [
      { required: true, message: "Provide a valid amount. Enter 0 if not applicable." },
      { pattern: new RegExp(/^[0-9]+$/), message: "Please enter valid amount." }
    ]
  };

  /**
  * @memberof TdsChallan
  * @type API
  * @returns Promise
  */
  static create = (queryData = {}, config = {}) => {
    return post(`tax-payments/v1/internal/challans/direct_tax/`, queryData, config).catch(
      (error) => ({
        success: false,
        data: (error.response && error.response.data) || {},
        status: (error.response && error.response.status) || 400,
      })
    );
  };

  update = (queryData = {}) => {
    return post(`tax-payments/v1/internal/challans/direct_tax/${this.id}/update/`, queryData, {}).catch(
      (error) => ({
        success: false,
        data: (error.response && error.response.data) || {},
        status: (error.response && error.response.status) || 400,
      })
    );
  };

  cancel = (queryData = {}) => {
    return post(`tax-payments/v1/internal/challans/direct_tax/${this.id}/cancel/`, queryData, {}).catch(
      (error) => ({
        success: false,
        data: (error.response && error.response.data) || {},
        status: (error.response && error.response.status) || 400,
      })
    );
  };
  /**
   * @memberof TdsChallan
   * @type API
   * @returns Promise
   */
  static list = (queryData = {}, config = {}) => {
    return get(`tax-payments/v1/internal/challans/direct_tax/`, queryData, config).catch(
      (error) => ({
        success: false,
        data: (error.response && error.response.data) || {},
        status: (error.response && error.response.status) || 400,
      })
    );
  };

  /**
  * @memberof TdsChallan
  * @type API
  * @returns Promise
  */
  downloadAdvice = (queryData = {}) => {
    return get(`tax-payments/v1/internal/challans/direct_tax/${this.id}/download/`, queryData, {}).catch(
      (error) => ({
        success: false,
        data: (error.response && error.response.data) || {},
        status: (error.response && error.response.status) || 400,
      })
    );
  };

  /**
   * @memberof TdsChallan
   * @type API
   * @returns Promise
   */
  static triggerFetch = (queryData = {}) => {
    queryData = { ...queryData };
    return get(`tax-payments/v1/internal/challans/direct_tax/fetch/`, queryData, {}).catch(
      (error) => ({
        success: false,
        data: (error.response && error.response.data) || {},
        status: (error.response && error.response.status) || 400,
      })
    );
  };

  /**
 * @memberof TdsChallan
 * @type API
 * @returns Promise
 */
  processPayment = (queryData = {}) => {
    queryData = { ...queryData, ...this.get() };
    return post(`tax-payments/v1/internal/challans/direct_tax/${queryData.id}/payment/initiate/`, queryData, {}).catch(
      (error) => ({
        success: false,
        data: (error.response && error.response.data) || {},
        status: (error.response && error.response.status) || 400,
      })
    );
  };

  /**
* @memberof TdsChallan
* @type API
* @returns Promise
*/
  fetchPaymentAttempts = (queryData = {}) => {
    queryData = { ...queryData, ...this.get() };
    return get(`tax-payments/v1/internal/challans/direct_tax/${queryData.id}/payment/attempts/`, queryData, {}).catch(
      (error) => ({
        success: false,
        data: (error.response && error.response.data) || {},
        status: (error.response && error.response.status) || 400,
      })
    );
  };

  /**
* @memberof TdsChallan
* @type API
* @returns Promise
*/
  approvePayment = (queryData = {}) => {
    queryData = { ...queryData, ...this.get() };
    return post(`tax-payments/v1/internal/challans/direct_tax/${queryData.approval_id}/approve_payment/`, queryData, {}).catch(
      (error) => ({
        success: false,
        data: (error.response && error.response.data) || {},
        status: (error.response && error.response.status) || 400,
      })
    );
  };

  /**
* @memberof TdsChallan
* @type API
* @returns Promise
*/
  updateSourceAccount = (queryData = {}) => {
    queryData = { ...queryData, ...this.get() };
    return put(`tax-payments/v1/internal/challans/direct_tax/${queryData.id}/source_account/`, queryData, {}).catch(
      (error) => ({
        success: false,
        data: (error.response && error.response.data) || {},
        status: (error.response && error.response.status) || 400,
      })
    );
  };


  /**
* @memberof TdsChallan
* @type API
* @returns Promise
*/
  fetchDirectTaxTAXCategories = (queryData = {}) => {
    queryData = { ...queryData, ...this.get() };
    return get(`v1/internal/utility/tds_tax_categories/`, queryData, {}).catch(
      (error) => ({
        success: false,
        data: (error.response && error.response.data) || {},
        status: (error.response && error.response.status) || 400,
      })
    );
  };

  /**
   * @memberof TdsChallan
   * @type Setter Method
   * @takes TdsChallan Params
   * @returns void
   */
  set = (values) => {
    Object.keys(values).forEach((x) => (this[x] = values[x]));
  };

  /**
   * @memberof TdsChallan
   * @type Getter Method
   * @returns TdsChallan
   */
  get = () => {
    return {
      id: this.id,
      pan: this.pan,
      tan: this.tan,
      pincode: this.pincode,
      state: this.state,
      major_head: this.major_head,
      minor_head: this.minor_head,
      assessment_year: this.assessment_year,
      nature_of_payment: this.nature_of_payment,
      tax_category_id: this.tax_category_id,
      financial_year: this.financial_year,
      income_tax: this.income_tax,
      surcharge: this.surcharge,
      education_cess: this.education_cess,
      equilization_levy: this.equilization_levy,
      interest: this.interest,
      other_fee: this.other_fee,
      other_amount: this.other_amount,
      penalty: this.penalty,
      penalty_code: this.penalty_code,
      challan_number: this.challan_number
    };
  };
}
